import React, { useEffect, useMemo, useState } from "react";
import { people } from "../../data/impactStories";
import { Quote } from "lucide-react";

export default function QuoteBand() {
  const pool = useMemo(() => people.filter((p) => p.quote), []);
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * pool.length));

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % pool.length), 12000);
    return () => clearInterval(t);
  }, [pool.length]);

  const p = pool[idx];

  return (
    <section data-testid="ri-quote-band" className="py-16 bg-[#0c0c0f] border-y border-white/5">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-10 text-center" key={p.id}>
        <Quote className="w-6 h-6 text-[#F5D000] mx-auto mb-5" />
        <blockquote className="ri-fade-up font-display text-xl sm:text-2xl lg:text-3xl text-white/90 italic leading-relaxed">
          “{p.quote}”
        </blockquote>
        <div className="mt-5 text-xs uppercase tracking-[0.25em] text-white/45">
          {p.name} · <span className="text-[#F5D000]">{p.role.split("·")[0].trim()}</span>
        </div>
      </div>
    </section>
  );
}
